<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p><a id="ded">
<div class="ctag1">For GLH <br/>Thanks</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113576_oeb_ded_r1.vue?e941f354